import { MutationTree } from 'vuex';
import { UserPreferences } from './types';
import { SUPPORTED_CURRENCIES } from '@resclick/data-access';
const supportedCurrencies = SUPPORTED_CURRENCIES.map((currency) => currency.code);

export const mutations: MutationTree<UserPreferences> = {
  setLocale: (state, payload) => {
    state.locale = payload;
  },
  setCountry: (state, payload) => {
    state.country = payload;
  },
  setCurrency: (state, payload) => {
    state.currency = supportedCurrencies.includes(payload) ? payload : 'EUR';
  },
  setPreferences: (state, payload) => {
    Object.assign(state, payload);
  },
};
